import React, { Component } from 'react';


class Terror extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Festival Escolar por el Bienestar Socioemocional</h2>
          </header>
          <div className="containerimagenblog">
            <img className="imagenBlog" src="images/Blog/portada2.jpg" alt="Dia Naranja" />
          </div>
          <span className="containerblog">
            <div className="align justify">
              <p>
              ¡GRACIAS!
              Las Noches de Terror en Dinoparque fueron todo un éxito.
              Ayer cerramos esta experiencia espeluznante y divertida con más de 700 valientes que se atrevieron a vivir la última noche del terror.
              Familias completas disfrutaron de las casas temáticas, los efectos audiovisuales y la ambientación que transformó el parque en un verdadero recorrido del miedo.
              En total, más de 1,200 asistentes nos acompañaron durante los dos días.
              Nos llena de alegría saber que, año con año, seguimos creando momentos que nuestros visitantes disfrutan y recuerdan con emoción.
               

              </p>
              <p>
                

              </p>
              <p>
                <b></b>
              </p>
              
            </div>
            <div className="containerimagenBlogmini">
              <img className="imagenBlogmini" src="images/Blog/festivalse1.jpg" alt="Festival1" />
              <img className="imagenBlogmini" src="images/Blog/festivalse2.jpg" alt="Festival2" />
              <img className="imagenBlogmini" src="images/Blog/festivalse3.jpg" alt="Festival3" />
               <img className="imagenBlogmini" src="images/Blog/festivalse4.jpg" alt="Festival4" />
              </div>
            <div>
              <div className="containerjuego">
                <a href="/blog" className="button">Regresar</a>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default Terror;